module.exports = __webpack_public_path__ + "img/title2.690973c3.png";